import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  SelectChangeEvent,
  Box,
} from "@mui/material";

import { PAYMENTS_STATUSES } from "../../../../constants";
import PaymentsByCategory from "../PaymentsByCategory";
import { ContainerBg } from "../../../../useGeneralStyles";
import { useFeedContext } from "../../../../context";

const PaymentsByStatus = (): React.ReactElement => {
  const { groupBy, setGroupBy, setSearch, search } = useFeedContext();

  const handleChange = (e: SelectChangeEvent<string>) => {
    setGroupBy(e.target.value as string);
  };
  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch({
      ...search,
      email: e.target.value,
    });
  };

  return (
    <ContainerBg>
      <Box mb="4px">
        <FormControl variant="outlined">
          <InputLabel>Filter by</InputLabel>
          <Select label="Filter by" autoWidth value={groupBy} onChange={handleChange}>
            {Object.keys(PAYMENTS_STATUSES).map((key) => {
              const status = PAYMENTS_STATUSES[key];
              return (
                <MenuItem key={key} value={status.status}>
                  {status.title}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <TextField
          name="email"
          onChange={handleChangeEmail}
          value={search.email}
          label="Filter by email"
          sx={{ marginLeft: "5px" }}
        />
      </Box>

      <PaymentsByCategory groupBy={groupBy} inputProps={{ max: 25 }} />
    </ContainerBg>
  );
};

export default PaymentsByStatus;
